/*! @azure/msal-common v16.6.1 2026-05-11 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.6.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
